import React from 'react';
import { PROFILE_TEMPLATE_PATH } from '@ApplicationWide/routes/admin/admin-urls';

const EditProfileTemplatePage = React.lazy(() =>
  import('../../../pages/Admin/ProfileSetupPage/tabs/ProfileTemplateTab/EditProfileTemplatePage'),
);

export default {
  route: [`${PROFILE_TEMPLATE_PATH}/edit/:id`],
  component: EditProfileTemplatePage,
  requiredRoles: ['admin', 'super_admin'],
  hasNavBar: true,
};
